import styled from 'styled-components';

export const Loading = styled.div`
  img {
    width: 50px;
    display: flex;
    margin: 200px auto;
  }
`;
